import useSWR from "swr";
import { configLibraryUrl } from "@/utils/Config";
import {
  type SampleDocumentWithFileLocation,
  type SampleDocument,
} from "../../utils";
import {
  OnboardingAccount,
  OnboardingBenefits,
  OnboardingBillOfLading,
  OnboardingInvoice,
  OnboardingLease,
  OnboardingRateConfirmation,
  OnboardingSummaryOfBenefits,
  OnboardingTask,
  OnboardingWorkOfficeCompanies,
} from "../ui/onboarding/icons";

export function useSampleDocuments() {
  const icons = {
    "summary-of-benefits": <OnboardingSummaryOfBenefits />,
    "bill-of-lading": <OnboardingBillOfLading />,
    benefits: <OnboardingBenefits />,
    account: <OnboardingAccount />,
    invoice: <OnboardingInvoice />,
    lease: <OnboardingLease />,
    task: <OnboardingTask />,
    "rate-confirmation": <OnboardingRateConfirmation />,
    "work-office-companies": <OnboardingWorkOfficeCompanies />,
  };
  const result = useSWR<SampleDocumentWithFileLocation[]>(
    `${configLibraryUrl}/samples/manifest_v2.json`,
    (url: string) => fetch(url).then((res) => res.json())
  );
  return {
    ...result,
    data: result.data?.map((sample): SampleDocument => ({
      ...sample.config_data,
      icon: icons[sample.config_data.icon as keyof typeof icons],
    })),
  };
}
